module.exports = __webpack_public_path__ + "static/img/responses-img.76aea1a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/responses-img.png
// module id = BkPV
// module chunks = 1